import React from 'react';
import { FunctionFactory } from 'survey-core';
import { CalorieTracking } from '../quiz/calories';
import { Goals } from '../quiz/goals';

const calorieSplashHtml = `
<div class="new-quote-container centered">
  <div class="splash-icon">{calorieIcon}</div>
  <div class="splash-header">
    <h1>{calorieTitle}</h1>
    <div class="quote">
      {calorieQuote}
    </div>
  </div>
</div> 
`;

const calorieSplashExpression = {
  name: "calorieQuote",
  expression: "renderCalorieQuote({calories}, {goals})",
};

function renderCalorieQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as CalorieTracking) {
    case CalorieTracking.NoIdea: {
      const goalsCalorieText = (() => {
        switch (params[1] as Goals) {
          case Goals.LoseFat:
            return "lose weight";
          case Goals.BuildMuscle:
            return "build muscle";
          case Goals.BuildMuscleAndLoseFat:
            return "lose fat";
        }
      })();
      return `We’ll show you how to start hitting your daily calorie goal easily to ${goalsCalorieText}, even if you’ve never tracked before.`;
    }
    case CalorieTracking.EatingMore:
    case CalorieTracking.EatingLess: {
      const goalsCalorieText = (() => {
        switch (params[1] as Goals) {
          case Goals.LoseFat:
            return "weight loss";
          case Goals.BuildMuscle:
            return "muscle building";
          case Goals.BuildMuscleAndLoseFat:
            return "fat loss";
        }
      })();
      return `Don’t worry! Now you have a clear target. We’ll show you how to easily tweak your diet and hit your ${goalsCalorieText} goal.`;
    }
    case CalorieTracking.PrettyClose: {
      return `That’s great to hear, you’ve already laid the foundation. We’ll help you build on it with even more structure and consistency.`;
    }
  }
}

FunctionFactory.Instance.register("renderCalorieQuote", renderCalorieQuote);

const calorieSplashElement = {
  name: 'calorie-splash',
  type: 'html',
  html: calorieSplashHtml,
}

function renderCalorieTitle(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as CalorieTracking) {
    case CalorieTracking.NoIdea:
      return "No problem!";
    case CalorieTracking.EatingMore:
    case CalorieTracking.EatingLess:
      return "You’re gaining clarity.";
    case CalorieTracking.PrettyClose:
      return "Let’s lock in.";
  }
}

const calorieSplashTitleExpression = {
  name: "calorieTitle",
  expression: "renderCalorieTitle({calories})",
};

FunctionFactory.Instance.register("renderCalorieTitle", renderCalorieTitle);
  
function renderCalorieIcon(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as CalorieTracking) {
    case CalorieTracking.NoIdea:
      return "👍";
    case CalorieTracking.EatingMore:
    case CalorieTracking.EatingLess:
      return "🎯";
    case CalorieTracking.PrettyClose:
      return "🔒";
  }
}

FunctionFactory.Instance.register("renderCalorieIcon", renderCalorieIcon);

const calorieSplashIconExpression = {
  name: "calorieIcon",
  expression: "renderCalorieIcon({calories})",
};
const CalorieSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      🥩 Nailing the basics
    </div>
  )
}

export {
  calorieSplashElement,
  calorieSplashExpression,
  CalorieSplashHeader,
  calorieSplashTitleExpression,
  calorieSplashIconExpression,
}